import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { navMenu } from '../../../utils/constants';
import { Drawer } from 'primeng/drawer';
import { Router } from '@angular/router';
import { Ga4Service } from '../../../services/ga4/ga4.service';
import { APP_ROUTES } from '../../../utils/route.constant';
import { DASHBOARD_PAGE_LOCATION, MENU, MENU_CONTACT_US_LINK, MENU_HOME_LINK, MENU_MY_PLAN_LINK, MENU_MY_SERVICE_REQUESTS_LINK, MENU_PAYMENTS_LINK, MENU_PERKS_BENEFITS_LINK, MENU_PROFILE_SETTINGS_LINK, REQUEST_SERVICE } from '../../../services/ga4/ga4.constant';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent {
  @ViewChild('drawerRef') drawerRef!: Drawer;
  @Input() visible: boolean = false;
  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() blockScroll: boolean = true;
  @Input() closable: boolean = true;
  @Input() promoslotVisible: boolean = true;
  @Input() requestServiceEnable: boolean = true;
  @Input('navItems') items: MenuItem[] | undefined = navMenu;

  constructor(private router: Router, private gaService: Ga4Service) { }

  /**
   * @description Close the drawer
   * @param e
   */
 closeCallback(): void {
    this.visible = !this.visible;
    this.drawerRef.onHide.emit(this.visible);
  }

  closeItem(route: any): void {
    // Force close the drawer if the current route matches the clicked route
    this.gaService.buttonClickEvent(MENU, this.getButtonName(route));
    if (this.router.url === route) {
      this.visible = false;
      this.drawerRef.onHide.emit(this.visible);
    }
  }

  /**
   * @description Navigate to the service request page
   */
  navigateToServiceRequest() {
    this.gaService.buttonClickEvent(MENU, REQUEST_SERVICE);
    this.router.navigate([APP_ROUTES.SERVICE_REQUEST]);
    if (this.router.url === APP_ROUTES.SERVICE_REQUEST) {
      this.closeCallback();
    }
  }

  /**
   * @description Navigate to the specified route
   * @param route
   */
  navigateToURL(route:string){
    this.gaService.buttonClickEvent(MENU, this.getButtonName(route));
    this.router.navigate([route])
  }

  getButtonName(route: string): string {
    let buttonName = '';

    switch (route) {
      case '/dashboard':
        buttonName = MENU_HOME_LINK;
        break;
      case '/my-plan':
        buttonName = MENU_MY_PLAN_LINK;
        break;
      case '/my-service-requests':
        buttonName = MENU_MY_SERVICE_REQUESTS_LINK;
        break;
      case '/payments':
        buttonName = MENU_PAYMENTS_LINK;
        break;
      case '/profile':
        buttonName = MENU_PROFILE_SETTINGS_LINK;
        break;
      case '/contact-us':
        buttonName = MENU_CONTACT_US_LINK;
        break;
      case '/perks-and-benefits':
        buttonName = MENU_PERKS_BENEFITS_LINK;
        break;
      default:
        buttonName = 'Unknown_Link';
        break;
    }
    return buttonName;
  }

}